import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../_actions";
import { Routes } from "../../_components";
import { userConstants } from "../../_constants";
import "./css/bsc-ward.scss";

const Headers = [
  "وجه کارت امتیازی متوازن (BSC)",
  "عنوان شاخص",
  "واحد اندازه گیری",
  "تارگت (هدف)",
  ...userConstants.months,
  // "وضعیت موجود",
];

const mergeCells = (data) => {
  let mergedData = data.map((row) => [...row]);
  for (let col = 0; col < Headers.length; col++) {
    let lastValue = null;
    let lastIndex = -1;
    for (let row = 0; row < data.length; row++) {
      if (data[row][col] !== "") {
        lastValue = data[row][col];
        lastIndex = row;
      } else if (lastValue !== null) {
        mergedData[lastIndex][col] += "#%&" + data[row][col];
        mergedData[row][col] = null;
      }
    }
  }
  return mergedData;
};

const replaceContinuousDuplicates = (items) => {
  let previous = null;
  return items.map((item) => {
    if (item === previous) {
      return "";
    } else {
      previous = item;
      return item;
    }
  });
};

const calcSectionClassName = (index, arr) => {
  return index < arr[0]
    ? `section section_1`
    : index < arr[1]
    ? `section section_2`
    : index < arr[2]
    ? `section section_3`
    : index < arr[3]
    ? `section section_4`
    : "";
};

const formatNumber = (number, unit, notFound = "-") => {
  if (["", null].includes(number)) return notFound;
  let temp = unit === "تومان" ? Number(number).toLocaleString() : number;
  return Number(temp) % 1 ? Number(temp).toFixed(2) : `${temp}`;
};

const formatData = (data) => {
  const separateByAspect = data.reduce(
    (acc, item) => ({
      ...acc,
      [item.score_card_aspect]: [...(acc[item.score_card_aspect] || []), item],
    }),
    {}
  );
  const sortedData = [
    ...(separateByAspect["مالی"] || []),
    ...(separateByAspect["جامعه و عرضه خدمات"] || []),
    ...(separateByAspect["فرآیندهای داخلی"] || []),
    ...(separateByAspect["رشد و یادگیری"] || []),
  ];
  const aspects = replaceContinuousDuplicates(
    sortedData.map(({ score_card_aspect }) => score_card_aspect)
  );

  const rowsData = sortedData.map((item, index) => {
    const intervals = {
      ماهانه: { length: 12, colSpan: 1 },
      "سه ماه یکبار": { length: 4, colSpan: 3 },
      "شش ماه یکبار": { length: 2, colSpan: 6 },
      سالانه: { length: 1, colSpan: 12 },
    };

    const { length, colSpan } = intervals[item.measure_interval] || {};
    let monthData = Array(length).fill("-");

    item.intervals.forEach(({ average, interval_number }) => {
      monthData[interval_number - 1] = formatNumber(
        average,
        item.measurement_unit
      );
    });

    return [
      aspects[index],
      <td className="title_td basic_cell">{item.title}</td>,
      <td className="measurement_td basic_cell">{item.measurement_unit}</td>,
      <td className="target_td basic_cell">
        {formatNumber(item.target, item.measurement_unit, "-")}
      </td>,
      ...monthData.map((month) => (
        <td
          className={`month_td ${calcColor(
            data.find(({ title }) => title === item.title),
            month
          )}`}
          colSpan={colSpan}
        >
          {month === null ? "-" : month}
        </td>
      )),
      // <td className="average_td basic_cell">
      //   {formatNumber(item.total_average, item.measurement_unit, "بدون مقدار")}
      // </td>,
    ];
  });

  const sectionsHeight = rowsData
    .map((row) => (row[0] === "" ? null : row[0]))
    .reduce((acc, item) => {
      if (item === null) acc[acc.length - 1]++;
      else acc.push(1);
      return acc;
    }, []);
  const sectionsHeightEnd = sectionsHeight.reduce(
    (acc, el, i) => (acc.push((acc[i - 1] || 0) + el), acc),
    []
  );
  return rowsData.map((row, rowIndex) =>
    row.map((item) => {
      if (
        typeof item === "object" &&
        item.props.className.includes("basic_cell")
      ) {
        return {
          ...item,
          props: {
            ...item.props,
            className: `${item.props.className} ${calcSectionClassName(
              rowIndex,
              sectionsHeightEnd
            )}`,
          },
        };
      }
      return item;
    })
  );
};

const calcColor = (intervals, average) => {
  if (average === "-") return "gray_cell";

  const { desirability, lower_limit, upper_limit } = intervals;
  if (lower_limit === null || upper_limit === null) return "gray_cell";

  const isIncreasing = desirability === "افزاینده";
  const isBelowLow = parseFloat(average) < +lower_limit;
  const isAtOrBelowLow = parseFloat(average) <= +lower_limit;
  const isAtOrAboveHigh = parseFloat(average) >= +upper_limit;
  const isWithin =
    parseFloat(average) > +lower_limit && parseFloat(average) < +upper_limit;

  if (isIncreasing) {
    return isBelowLow
      ? "red_cell"
      : isAtOrAboveHigh
      ? "green_cell"
      : "yellow_cell";
  } else {
    return isWithin
      ? "yellow_cell"
      : isAtOrBelowLow
      ? "green_cell"
      : "red_cell";
  }
};

const BscWard = () => {
  let uniqueIndexTitle = 1;
  const dispatch = useDispatch();
  const globalStorage = useSelector((state) => state.globalStorage);
  const [intervals, setIntervals] = useState([]);
  const [intervalsFormatted, setIntervalsFormatted] = useState([]);

  useEffect(() => {
    const waveElement = document.querySelector(".wave");
    waveElement.classList.add("hidden");
    return () => {
      waveElement.classList.remove("hidden");
    };
  }, []);

  useEffect(() => {
    dispatch(
      userActions.API(
        "get",
        `v2/get_collector_indicators_with_data?is_collector=${true}&user_id=${
          globalStorage.me.id
        }&year=${globalStorage.year}`
      )
    ).then((res) => {
      getMonitors(res.data.indicators.filter(({ see_bsc }) => see_bsc));
    });
    // eslint-disable-next-line
  }, [globalStorage.year]);

  const getMonitors = (collectorData) => {
    dispatch(
      userActions.API(
        "get",
        `v2/get_monitor_indicators_with_data?is_collector=${false}&user_id=${
          globalStorage.me.id
        }&year=${globalStorage.year}`
      )
    ).then((res) => {
      const monitorData = res.data.indicators.reduce(
        (acc, { indicator }) => (indicator.see_bsc ? [...acc, indicator] : acc),
        []
      );
      const data = [...monitorData, ...collectorData];
      setIntervals(data);
      setIntervalsFormatted(formatData(data));
    });
  };

  const mergedData = mergeCells(intervalsFormatted);

  const onFilterList = (event) => {
    const { checked } = event.target;
    if (checked) {
      const filteredData = intervals.filter(
        ({ total_average }) => total_average !== null
      );
      setIntervalsFormatted(formatData(filteredData));
    } else {
      setIntervalsFormatted(formatData(intervals));
    }
  };

  return (
    <div className="container-fluid bsc_ward_parent">
      <Routes page="collector/bsc-ward" />
      <div className="filter_parent">
        <input type="checkbox" id="filter-empty" onClick={onFilterList} />
        <label htmlFor="filter-empty" className="filter_label">
          فیلتر بدون مقدار
        </label>
      </div>
      <div className="table_wrapper">
        <table className="bsc_ward_table">
          <thead>
            <tr>
              {Headers?.map((header, index) => (
                <th
                  key={index}
                  className={3 < index && index < 16 ? "month_th" : ""}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {mergedData?.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, cellIndex) => {
                  if (cell !== null) {
                    if (typeof cell === "object") {
                      return cell;
                    }
                    return (
                      <td
                        key={cellIndex}
                        rowSpan={
                          cell.includes("#%&") ? cell.split("#%&").length : 1
                        }
                        className={`side_title_${uniqueIndexTitle++}`}
                      >
                        {cell.replace(/#%&/g, "")}
                      </td>
                    );
                  }
                  return null;
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export { BscWard };
